module.exports = __webpack_public_path__ + "img/qilin-f-stage1.1b369f27.png";